import Option from "../components/systemAdmin/Option";

export const prepareOptions = (options) => {
    const changed = {};

    options.forEach(option => {
        changed[option.code] = Option.getValue(option);
    })

    return changed;
}

export const mapStatuses = (statuses, quantities) => {

    const { online, offlineSiteClosed, offlineSiteOpen, pending, authReq } = statuses;
    const { onlineQty, offlineSiteClosedQty, offlineSiteOpenQty, pendingQty, authReqQty } = quantities;

    return [
        {
            key: "online",
            color: "green",
            text: "Online - Operational",
            disabled: !online,
            quantity: onlineQty
        },
        {
            key: "pending",
            color: "orange",
            text: "Online - Non Operational",
            disabled: !pending,
            quantity: pendingQty
        },
        {
            key: "offlineSiteOpen",
            color: "red",
            text: "Offline - Site Open",
            disabled: !offlineSiteOpen,
            quantity: offlineSiteOpenQty
        },
        {
            key: "offlineSiteClosed",
            color: "blue",
            text: "Offline - Site Closed",
            disabled: !offlineSiteClosed,
            quantity: offlineSiteClosedQty
        },
        /*
        {
            key: "authReq",
            color: "yellow",
            text: "Install - Auth. Req.",
            disabled: !authReq,
            quantity: authReqQty
        }
        */
    ];
}

export const viewOptions = [
    { key: "Machine Status", value: 0, text: "Machine Status" },
    { key: "Current Comms Status", value: 1, text: "Current Comms Status" },
    { key: "Machine Operational Filters", value: 2, text: "Machine Operational Filters" }
]